import { FC, useEffect, useState } from 'react';
import Card from '../Card/Card';
import Radio from '../Radio/Radio';
import styles from './RadioCard.module.css';
import { RadioCardProps } from './RadioCard.types';

const RadioCard: FC<RadioCardProps> = ({ title, children, checked, readOnly, onChange, id, name }) => {
  const [open, setOpen] = useState(checked);

  useEffect(() => {
    if (checked !== undefined) setOpen(checked);
  }, [checked]);

  return (
    <Card>
      <div className={styles.titleRow}>
        <Radio label="" name={name} id={id} checked={checked} readOnly={readOnly} onChange={onChange} />
        <div className={styles.title}>{title}</div>
      </div>
      {open && <div>{children}</div>}
    </Card>
  );
};

export default RadioCard;
